"use strict";

import $ from "jquery";

export default function productActions(scope) {
    $(scope.link).on("click touch", function (e) {
        e.preventDefault();
        const form = $(this).parent();
        const spinner = $(".module__loading");
        spinner.addClass("active");
        $.ajax({
            url: form.attr("action"),
            method: form.attr("method"),
        }).done(function (data) {
            spinner.removeClass("active");
            window.location = data;
        });
    });
}
